/*
Author: Liubo
Date: 2018-09-05
Desc: Vuex 状态管理
*/
import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import login from "./modules/login";
// import routeCache from "./modules/routeCache";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        login
        // routeCache
    }
});
